import React, { Component } from 'react';
import RegisteredArticles from './RegisteredArticles';

function withArticleMetaData(Wrapped) {
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
  			isLoading: false,
  			posts: []
  		}
    }

    componentDidMount() {
      this.collectArticleMetaData();
    }

    async collectArticleMetaData() {
  		var article_meta = [];
  		for (const article of RegisteredArticles) {
  			await fetch(`/articles/${article}/meta.json`).then(r => r.json()).then(m => {
  	      article_meta.push(m);
        })
  		}
      console.log(article_meta)
  		this.setState({
  			posts: article_meta.sort((a,b) => {
  				if (a.created < b.created)
  				 	return 1
  				if (a.created > b.created)
  					return -1

  				return 1
  			})
  		})
  	}

    render() {
      return <Wrapped posts={this.state.posts} {...this.props} />;
    }
  }
}

export default withArticleMetaData;



// WEBPACK FOOTER //
// ./src/withArticleMetaData.js